import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const queryOrderDetail = async (params: object) => {
  return await GET({
    url: Api.queryOrderDetail,
    params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const confirmSign = async (params: object) => {
  return await POST({
    url: Api.confirmSign,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
